import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import DeleteIcon from "@mui/icons-material/Delete";
import image from "../logos/nodata.png";
import "./CommonDashboard.css";
import { useState } from "react";


import ConfirmationDialog from "./ConfirmationDialog";
import {
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import { Button } from "@mui/material";
import EditIcon from '@material-ui/icons/Edit';
import { useSelector, useDispatch } from "react-redux";


import { CssBaseline } from "@material-ui/core";
import Table from "@material-ui/core/Table";

import { setDevice } from "../redux/slices/deviceSlice";
import SingleLinkModal from "./SingleLinkModal";
import EditDeviceForm from "./EditDeviceForm";
import BulkLinkModal from "./BulkLinkModal";
import MyDeviceForm from "./MyDeviceForm";

const api = localStorage.getItem("api");
const theme = createMuiTheme({
  spacing: 2,
  typography: {
    fontSize: 12,
  },
});

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDataGrid-row.Mui-selected": {
      backgroundColor: "#e0e0e0",
    },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#fafafa",
    },
    "& .MuiDataGrid-cell": {
      fontWeight: "normal",
      fontSize: "0.75rem",
      color: "rgba(0, 0, 0, 0.87)",
      letterSpacing: "0.01071em",
    },
    "& .MuiDataGrid-cell--textLeft": {
      textAlign: "left",
    },
    "& .MuiDataGrid-cell--textCenter": {
      textAlign: "center",
    },
    "& .MuiDataGrid-cell--textRight": {
      textAlign: "right",
    },
    "& .MuiDataGrid-columnsContainer": {
      backgroundColor: "#fafafa",
    },
    "& .MuiDataGrid-iconSeparator": {
      display: "none",
    },
  },
  table: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: `calc(100% - ${theme.spacing(3)}px)`,
    overFlow: "hidden",
  },
  buttonDiv: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    padding: "0 10%"
   
  },
}));

const DeviceTable = () => {
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const headers = useSelector((state) => state.header);
  const classes = useStyles();
  const dispatch = useDispatch();
  const devicedata = useSelector((state) => state.device);
  const meetingSpaces=useSelector((state)=>state.allmeetingspaces)
  const meetingSpaceData=meetingSpaces?.allmeetingspaces
  const [selectedIds, setSelectedIds] = useState([]);
  const [singleItemLinkId,setSingleItemLinkId]=useState(null);
  const[singleEditId,setSingleEditId]=useState(null);
  
  
  const columns = [
    { field: "id", headerName: "ID", flex: 0.5 },
    { field: "serial", headerName: "Serial", flex: 1 },
    { field: "name", headerName: "Name", flex: 1 },
    { field: "ipAddress", headerName: "IP address", flex: 1 },
    {
      field: "portNumber",
      headerName: "Port Number",
      flex: 1,
    },
    { field: "model", headerName: "Model", flex: 0.5 },
    {
      field: "type",
      headerName: "Type",
      flex: 1,
    },
   
    {
        field: "meetingLinkId",
        headerName: "Link Id",
        flex: 1,
        valueGetter: (params) => {
          const linkId = params.row.meetingLinkId;
          const link = meetingSpaceData?.find((link) => link.id === linkId);
          return link ? link.name : "Not Linked";
        },
      },
      // {
      //   field: "link",
      //   headerName: "Link",
      //   flex:1.2,
      //   renderCell: (params) => (
      //     <Button
      //       variant="outlined"
      //       size="small"
      //       startIcon={<LinkIcon />}
      //       color="primary"
      //       onClick={() => handleSingleLink(params.row.id)}
      //       disabled={loading}
      //     >
      //       {loading ? "Linking..." : "Link"}
      //     </Button>
      //   ),
      // },
      {
        field: "edit",
        headerName: "Edit",
        flex:1,
        
        renderCell: (params) => (
          <Button
            variant="outlined"
            size="small"
            startIcon={<EditIcon />}
            color="primary"
            onClick={() => handleEdit(params.row.id)}
            disabled={loading}
          >
            {loading ? "Editing..." : "Edit"}
          </Button>
        ),
      },
      {
        field: "delete",
        headerName: "Delete",
        flex:1.2,
        renderCell: (params) => (
          <Button
            variant="outlined"
            size="small"
            startIcon={<DeleteIcon />}
            color="error"
            onClick={() => handleDelete(params.row.id)}
            disabled={loading}
          >
            {loading ? "Deleting..." : "Delete"}
          </Button>
        ),
      },
  ];

 
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);

  const handleDelete = (id) => {
    setDeleteItemId(id);
    setShowConfirmationDialog(true);
  };

  const handleConfirmDelete = () => {
    setShowConfirmationDialog(false);
    setLoading(true);

    axios
      .delete(api+`/device?id=${deleteItemId}`, headers)
      .then(() => {
        setRows((prevRows) => {
          
          const updatedRows = prevRows?.filter((row) => row.id !== deleteItemId);
          dispatch(setDevice(updatedRows));
          return updatedRows;
        });
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCancelDelete = () => {
    setShowConfirmationDialog(false);
  };
  const handleEdit = (id) => {
    setSingleEditId(id);
  };
 
  
  const handleSingleLink = (id) => {
    
    setSingleItemLinkId(id);
    const requestBody =[{ id, meetinglinkid: "" }];
    

    axios
      .post(api + "/device/link", requestBody, headers)
      .then((response) => {
       
        dispatch(setDevice(response.data));
      })
      .catch((error) => {
        console.error(error);
      });
    
  };
  
 


  

  React.useEffect(() => {
    if (devicedata.device) setRows(devicedata.device);
  }, [devicedata.device]);

  return (
    <>
      
      <div className={classes.buttonDiv}>
              <BulkLinkModal
                open={true}
                selectedIds={selectedIds}
                onClose={() => setSelectedIds(null)} 
              />
              
              <MyDeviceForm/>
      </div>


      {rows?.length > 0 ? (
        <CssBaseline>
          <ThemeProvider theme={theme}>
            <Table classes={classes.table}>
              <div style={{ padding: "2.5% 10%" }}>
                <DataGrid
                  rows={rows}
                  columns={columns}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 5,
                      },
                    },
                  }}
                  pageSizeOptions={[5]}
                  checkboxSelection
                  disableRowSelectionOnClick
                  onRowSelectionModelChange={(ids) => {
                    
                    setSelectedIds(ids);
                  }}
                 
                 
                />
              </div>
            </Table>

            {singleEditId !== null && (
              <EditDeviceForm 
                selectedItemId={singleEditId}
                deviceData={devicedata.device}
               
                handleClose={() =>   setSingleEditId(null)} 
              />
            )}
            {showConfirmationDialog && (
        <ConfirmationDialog
          open={showConfirmationDialog}
          onClose={handleCancelDelete}
          onConfirm={handleConfirmDelete}
        />
      )}  
        {singleItemLinkId !== null && (
              <SingleLinkModal
                open={true}
                id={singleItemLinkId}
                onClose={() => setSingleItemLinkId(null)} // Close the modal on update or cancel
              />
            )}
          
          </ThemeProvider>
        </CssBaseline>
      ) : (
        <div className="error-container">
          <div className="error">
            <img className="img1" src={image} alt="" />
          </div>
        </div>
      )}
    </>
  );
};

export default DeviceTable;
